export interface ModelPresentationMetadata {
    default?: boolean
    legacy?: boolean
}

function modelPresentationRank(model: ModelPresentationMetadata): number {
    if (model.default) return 2
    if (model.legacy) return 1
    return 0
}

export function isActiveModel(model: ModelPresentationMetadata): boolean {
    return !model.default && !model.legacy
}

export function sortModelsForPresentation<T extends ModelPresentationMetadata>(models: readonly T[]): T[] {
    return models
        .map((model, index) => ({ model, index }))
        .sort((left, right) => modelPresentationRank(left.model) - modelPresentationRank(right.model) || left.index - right.index)
        .map(({ model }) => model)
}
